import Image from "components/atoms/Img";

export function Wave({
  sectionTop,
  sectionBottom,
  children,
  srcTop,
  srcBottom,
  imgWidthTop,
  imgHeightTop,
  imgWidthBottom,
  imgHeightBottom,
  background,
  heightBottom,
  ...props
}) {
  const customStyle = () => {
    if (props.style && Object.keys(props.style).length > 0) {
      return props.style;
    }

    return { top: "100px" };
  };

  return (
    <div>
      <div className="relative overflow-hidden">
        {sectionTop && (
          <div className="container relative z-10">{sectionTop}</div>
        )}
        <div
          className={"absolute hidden h-full  w-full lg:block "}
          style={customStyle()}
        >
          <Image
            src={srcTop}
            width={imgWidthTop || 1920}
            height={imgHeightTop || 125}
            className="w-full"
            wrapper={{ className: " w-full hidden lg:block" }}
            alt="Wave bottom"
          />
          <div
            className={`${background} absolute z-0 hidden h-full  w-full lg:block`}
          ></div>
        </div>
      </div>
      <div className={`${background}`}>{children}</div>

      <div className={" lg:relative  lg:overflow-hidden"}>
        {sectionBottom && (
          <div className=" relative z-10 p-1.5 pb-10 lg:container lg:pb-20">
            {sectionBottom}
          </div>
        )}
        <div className="absolute top-0 hidden h-full w-full lg:block">
          <div
            className={`${background} ${heightBottom} top-0  hidden w-full lg:block`}
          ></div>
          <div className="relative  z-0 hidden lg:block ">
            <Image
              src={srcBottom}
              width={imgWidthBottom || 1920}
              height={imgHeightBottom || 125}
              className="w-full"
              wrapper={{ className: " w-full  hidden lg:block" }}
              alt="Wave bottom"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
